// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tzLH","top":"styles_top__1Z6EU"};